<template>
  <div>
    <Navbar />
    <Header/>
    <Content/>
    <Footer/>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Header from '@/components/SasAdmission/Header.vue';
import Content from '@/components/SasAdmission/Content.vue';
import Footer from '@/components/Footer.vue';
export default {
  name: 'SasAdmission',
  components: {
    Navbar,
    Header,
    Content,
    Footer
  }
}
</script>

<style scoped>

</style>